import React, { useEffect, useState } from "react";
import axios from "axios";

const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
const API = `${ENV_API_BASE_URL}/api/blog-page`;

const EMPTY_FORM = {
  topLabel: "",
  title: "",
  breadcrumbLabel: "",
  sectionTitle: "",
  description: "",
};

function BlogPageContent() {
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(API);
      setFormData({
        ...EMPTY_FORM,
        ...(res.data?.data || {}),
      });
    } catch (error) {
      console.error("Failed to load blog page content:", error);
      setFormData(EMPTY_FORM);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      await axios.post(API, formData);
      await fetchData();
    } catch (error) {
      console.error("Save failed:", error);
      alert(error.response?.data?.message || "Failed to save blog page content");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container pt-5 mt-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0">Blog Page Content</h4>
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={fetchData}
          disabled={loading || saving}
        >
          Reload Saved Content
        </button>
      </div>

      {loading ? (
        <div className="card p-4 text-center text-muted">Loading blog page content...</div>
      ) : (
        <form onSubmit={handleSubmit} className="card p-4">
          <div className="mb-3">
            <label className="form-label">Top Label</label>
            <input
              type="text"
              className="form-control"
              name="topLabel"
              value={formData.topLabel}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Page Title</label>
            <input
              type="text"
              className="form-control"
              name="title"
              value={formData.title}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Breadcrumb Label</label>
            <input
              type="text"
              className="form-control"
              name="breadcrumbLabel"
              value={formData.breadcrumbLabel}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Section Title</label>
            <input
              type="text"
              className="form-control"
              name="sectionTitle"
              value={formData.sectionTitle}
              onChange={handleChange}
            />
          </div>

          <div className="mb-4">
            <label className="form-label">Description</label>
            <textarea
              className="form-control"
              rows="4"
              name="description"
              value={formData.description}
              onChange={handleChange}
            />
          </div>

          <div className="d-flex gap-2">
            <button className="btn btn-success" type="submit" disabled={saving}>
              {saving ? "Saving..." : "Save Content"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={fetchData}
              disabled={saving}
            >
              Reset to Saved
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

export default BlogPageContent;
